
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 24000 16000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#00267f","d":"M0 0h24000v16000H0z"}}),_c('path',{attrs:{"fill":"#ffc726","d":"M8000 0h8000v16000H8000z"}}),_c('path',{attrs:{"id":"a","fill":"#000","d":"M12000 4124c-260 709-525 1447-1092 2012 176-58 484-110 682-105v2982l-842 125c-30-3-40-50-40-114-81-926-300-1704-552-2509-18-110-337-530-91-456 30 4 359 138 307 74-448-464-1103-798-1739-897-56-14-89 14-39 79 844 1299 1550 2832 1544 4651 328 0 1123-194 1452-194v2104h415l95-5876z"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"matrix(-1 0 0 1 24000 0)"}})])
          )
        }
      }
    